import { useCallback, useState } from 'react';

import { useLanguage } from '../../contexts/language';

import { NoteField } from '../note-field';

import styles from './style.module.css';

// The clinician's side of a review: the note on the whole test, which saves
// as it is written, and Mark as reviewed, which is the only thing that marks
// it (C35): opening the test or writing notes never does, and it can be
// undone. onReviewed is given the new state and settles once it is stored
// and the page shows it.
export function ReviewPanel({ attempt, patientName, onReviewed }) {
  const { text, translate } = useLanguage();
  const [ busy, setBusy ] = useState(false);
  const [ error, setError ] = useState();
  const reviewed = attempt.reviewedAt != null;

  const toggle = useCallback(function() {
    setBusy(true);
    setError();

    return onReviewed(reviewed === false).then(function() {
      setBusy(false);
    }).catch(function(failed) {
      setBusy(false);
      setError(failed.message);
    });
  }, [ onReviewed, reviewed ]);

  let label = text.markReviewed;
  let className = `${ styles.button } ${ styles.primary }`;

  if (reviewed === true) {
    label = text.markNotReviewed;
    className = styles.button;
  }

  let message = null;

  if (error != null) {
    message = <span className={ styles.error } role='alert'>{ translate(error) }</span>;
  }

  return (
    <section className={ styles.panel } aria-label={ text.yourReview }>
      <NoteField
        id='review-test-note'
        label={ text.noteOnTest }
        placeholder={ text.noteOnTestPlaceholder }
        attemptId={ attempt.id }
        position={ null }
        initial={ attempt.note }
        rows={ 6 }
      />

      <span className={ styles.hint }>{ text.reviewHint.replace('{name}', patientName) }</span>

      <button className={ className } type='button' disabled={ busy } onClick={ toggle }>{ label }</button>

      { message }
    </section>
  );
}
